export const OverlayComponentTypes: Array<string> = ['MODAL', 'INLINE_MODAL'];
